import React, { useState, useEffect, useRef }  from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";

//import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';

import { formatPrice, convertNum, setCursorWaiting } from '../../../utils'

export const CollapseLease = ({dropdownCallback, selectCallback, setSelectedLeaseOption, ...props }) => {
    const { t, i18n } = useTranslation(['payments', 'general']);

    const summaryCalculator = window.summaryCalculator;
	const gtmHelper = new GTMHelper();

    const [collapseOpenContent, setCollapseOpenContent] = useState('');

    const [isCollapsed, setIsCollapsed] =  useState(false);
    const [didInit, setInit] = React.useState(false);
    const collapseRef = useRef();

    const [update, setForceUpdate] =  useState('');

    function leaseTermCanBeDisplayed(term) {
        const allowedTerm = [36,39,42,45,48,51,54,57,60];

        return allowedTerm.includes(term);
    }

    function hasRatePercentageDiscount(leaseElement) {
        return (Number.parseFloat(leaseElement.leaseRate) !== Number.parseFloat(leaseElement.leaseRateDiscounted));
    }
    
    function getLeaseOptions(financialInfo) {
        if (summaryCalculator.getResponsesHasError() === true)
        return (
            <>
            <div className='mz-finance-options__financial-element-error-msg'>{t("general:contact_a_dealer")}</div>
            </>
        ) 
        else
        return (
            <ul className="mz-lease-options__financial-element-list mz-collapse__box--element-list">
                {summaryCalculator.LoyaltyChecked ?
                <li className="loyalty-title">{t("payments:mazda_loyalty_collapse_title")}</li>: ''}
                <li className="mz-lease-options__financial-element mz-collapse__box--element headers">
                    <span>{t("months")}</span><span>{t("rate")}</span><span>{t("weekly_payment")}</span><span>{t("bi_weekly_payment")}</span><span>{t("monthly_payment")}</span>
                </li>
                { financialInfo.calculatedLease.leaseValues.map((leaseElement, index) => {
                    if (leaseTermCanBeDisplayed(leaseElement.term)){
                        return (
                            <>
                            <li className="mz-lease-options__financial-element mz-collapse__box--element" key={index}>
                                <span><input type="checkbox" name="leaseTermOptions" data-term-selected={leaseElement.term} value={index} onChange={itemClick} checked={parseInt(summaryCalculator.LeaseTermIndex) === index ? true : false} id={leaseElement.term +'__months'} /><label htmlFor={leaseElement.term + '__months'}>{leaseElement.term}</label></span>
                                {summaryCalculator.LoyaltyChecked && hasRatePercentageDiscount(leaseElement) ? 
                                    <span className="rate text--red"><span className='rate-strike '>{convertNum(leaseElement.leaseRate, 2)}% </span> {convertNum(leaseElement.leaseRateDiscounted, 2)}%</span>:
                                    <span className="rate">{convertNum(leaseElement.leaseRate, 2)}%</span>
                                }
                                <span className="weekly"><span>{formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly'])}</span></span>
                                <span className="biWeekly"><span>{formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly'])}</span></span>
                                <span className="weekly"> <span>{formatPrice(leaseElement[summaryCalculator.IncludeTaxes ? 'monthlyWithTaxes' : 'monthly'])}</span></span>
                            </li>
                            {summaryCalculator.LoyaltyChecked && !hasRatePercentageDiscount(leaseElement) ? 
                                <li className="text--center text--red" style={{'font-size': '0.6rem', 'margin-top': '-16px'}}>
                                    <span className="loyalty">{t("payments:item_contains_discount", { discount: formatPrice(summaryCalculator.Incentives.loyalty.cash_value) })}</span>
                                </li>: null}
                            </>
                        )
                    }
                })}
            </ul>
        )
    }
    
    async function handleClick(e) {
        const financialInfo = await summaryCalculator.RecalculateFinancialInfo();

        setCollapseOpenContent(getLeaseOptions(financialInfo));

        setIsCollapsed(!isCollapsed);

        setInit(false);

        setForceUpdate(Math.random());

        gtmHelper.setGTM({'action':'Collapse', 'type': 'Lease Term', 'value': !isCollapsed}, true , false);
    }

    function itemClick(e) {
        summaryCalculator.LeaseTermIndex = parseInt(e.target.value);
        summaryCalculator.LeaseTerm = parseInt(e.target.getAttribute("data-term-selected"));
        setSelectedLeaseOption(e.target.value);

        selectCallback();
        
        setCollapseOpenContent(getLeaseOptions(summaryCalculator.FinancialInfo));

        gtmHelper.setGTM({'action':'Checkbox', 'type': 'Lease Term', 'value': e.target.dataset['termSelected']}, true , false);
    }

    function getDisplayedRate() {
        const leaseElement = summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex];

        if (summaryCalculator.getResponsesHasError() === true)
            return convertNum(0,2);        
        else {
            //return convertNum(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate,2);
            if (hasRatePercentageDiscount(leaseElement))
                return convertNum(leaseElement.leaseRateDiscounted,2)
            else
                return convertNum(leaseElement.leaseRate,2);
        }
    }

    useEffect(() => {
        (async () => {
            setCursorWaiting(true);

            const financialInfo = await summaryCalculator.RecalculateFinancialInfo();

            setCollapseOpenContent(getLeaseOptions(financialInfo));

            //setForceUpdate(Math.random());

            setCursorWaiting(false);
        })();
    }, [summaryCalculator.AnnualMileage]);

    useEffect(() => {
        (async () => {
            setCursorWaiting(true);

            const financialInfo = await summaryCalculator.RecalculateFinancialInfo();

            setCollapseOpenContent(getLeaseOptions(financialInfo));
    
            setInit(false);
            //setIsCollapsed(false);
            const collapse = collapseRef.current;
            collapse.style.height = null;
            //collapse.style.removeProperty('height');
            
            //setForceUpdate(Math.random());
            //window.mzAnimator.animateHeight(collapse, 'CollapseListLease', true);

            setCursorWaiting(false);            
        })();
    }, [summaryCalculator._tradeInValue, summaryCalculator._downPaymentValue, summaryCalculator.LoyaltyChecked, summaryCalculator.GraduateChecked, summaryCalculator.MilitaryChecked, summaryCalculator.FirstTimeOwnerChecked, summaryCalculator.IncludeFees, summaryCalculator.IncludeTaxes, summaryCalculator.IncludeRebates]);

    useEffect(() => {
        (async () => {
            const collapse = collapseRef.current;

            if(typeof window.mzAnimator === 'object' && !didInit){
                window.mzAnimator.animateHeight(collapse, 'CollapseListLease', 'init');
                setInit(true);
                window.mzAnimator.animateHeight(collapse, 'CollapseListLease', isCollapsed);
            } 
            else {
                window.mzAnimator.animateHeight(collapse, 'CollapseListLease', isCollapsed);
            }
            
            collapse.className = 'mz-collapse__box visible ' + (!isCollapsed ? 'mz-collapse__box--finance-collapsed' : 'mz-collapse__box--finance-expanded');

            if(isCollapsed === false)
                dropdownCallback();
        })();
    },[isCollapsed, didInit]);

    useEffect(() => {
        console.log('reupdating lease collapse');
    }, [update]);

    useEffect(() => {
        setForceUpdate(Math.random());
    }, [collapseOpenContent]);

    return (
        <div className="mz-collapse mz-collapse--finance">
            <button
                onClick={handleClick}
                className="mz-collapse__button"
            >
                <div className="mz-collapse__cartext-container">
                    <p className="mz-collapse__text">{t("term")}: {summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term} {t("payments:months_lowercase")} {getDisplayedRate()}%</p>
                </div>
                <i className={ isCollapsed ? "mz-svg mz-svg-chevron_small open  mz-svg--grey" : "mz-svg mz-svg-chevron_small  mz-svg--grey"}></i>
            </button>
            <div className="mz-collapse__box" ref={collapseRef}>{collapseOpenContent}</div>
        </div>
    )
}

CollapseLease.propTypes = {
}

CollapseLease.defaultProps = {
}

export default CollapseLease;